import { render, staticRenderFns } from "./timer-pre-sets.component.vue?vue&type=template&id=8572b4fc"
import script from "./timer-pre-sets.component.ts?vue&type=script&lang=ts&external"
export * from "./timer-pre-sets.component.ts?vue&type=script&lang=ts&external"
import style0 from "./timer-pre-sets.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports